import { ImageVariants } from "./enums";
const contain = {
    objectFit: "contain",
    width: "100%",
    height: "100%"
};
const cover = {
    objectFit: "cover",
    width: "100%",
    height: "100%"
};
const ratio_3x4 = {
    position: "relative",
    pb: "133%",
    height: 0
};
const ratio_4x3 = {
    position: "relative",
    pb: "75%",
    height: 0
};
const ratio_16x9 = {
    position: "relative",
    pb: "56%",
    height: 0
};
const ratio_21x9 = {
    position: "relative",
    pb: "39%",
    height: 0
};
const ratio1x1 = {
    position: "relative",
    pb: "100%",
    height: 0
};
const ratio_none = {
    position: "relative",
    height: "auto",
    width: "100%"
};
const ratio_1x1_and_21x9 = {
    position: "relative",
    height: 0,
    pb: ["100%", null, "39%"]
};
export const ThemeImages = {
    [ImageVariants.contain]: contain,
    [ImageVariants.cover]: cover,
    [ImageVariants.ratio_3x4]: ratio_3x4,
    [ImageVariants.ratio_4x3]: ratio_4x3,
    [ImageVariants.ratio_16x9]: ratio_16x9,
    [ImageVariants.ratio_21x9]: ratio_21x9,
    [ImageVariants.ratio_1x1]: ratio1x1,
    [ImageVariants.ratio_none]: ratio_none,
    [ImageVariants.ratio_1x1_and_21x9]: ratio_1x1_and_21x9
};
//# sourceMappingURL=images.js.map